import {
  type EventReturnTypes,
  type TEventContext,
  trackEvent,
} from '@otter-ai/telemetry';
import { type ValueOf } from '@otter-ai/ts-toolkit';
import { useQuery } from '@tanstack/react-query';
import { assign } from 'radash';
import { useCallback } from 'react';
import { userLocationQueryCreator } from '#query';

/**
 * Hooks that provides tracking for events where user geolocation is required.
 */
export function useTrackEventWithGeoLocation() {
  const { data: userGeoipLocation } = useQuery(userLocationQueryCreator());

  /**
   * Calls `trackEvent` with user geolocation as context.
   * @param event event object
   * @param context supplementary event context
   */
  const trackEventWithGeoIP = useCallback(
    (event: ValueOf<EventReturnTypes>, context?: TEventContext) => {
      const countryCode = userGeoipLocation?.country_code;
      const enrichedContext = countryCode
        ? assign({ user: { country_api: countryCode } }, context ?? {})
        : context;
      trackEvent(event, enrichedContext);
    },
    [userGeoipLocation],
  );

  return {
    trackEventWithGeoIP,
  };
}
